<template>
  <div><div>
    <div class="relative mx3 bb-mt2pt56">
      <div id="scrollView" class="bb-pl20p bb-xl-pl0 bb-pr20p bb-xl-pr40p bb-min-h20
        bb-ff2 bb-fs1pt2 bb-fc1 bb-ofy-auto bb-hyphens-auto border-box center bb-xl-justify">
        <div class="bb-ff2 bb-fs1pt2 bb-fc2">
          {{ $lang.messages.refund_pol }}
        </div>
        <br/>
        <div class="bb-ff2 bb-fs1pt29 bb-fc3">
          Bigbang doesn’t want you to miss out on a spectacular experience.
          However, we’re here to help if you wish to cancel your booking. 
          <br/><br/>
          After your online booking, the payment card used will be checked for
          validity, and the Bigbang crew will be expecting to see you at the
          time and date of your booking. 
          <br/><br/>
          Payments are only executed once you show up to your allotted booking
          at Bigbang. In cases of no-show, the payment will be canceled after
          one business day. 
        </div>
      </div>
      <div id="scrollGradient" class="absolute bottom-0 left-0 right-0 bb-h25 bb-gradient1
        bb-events-none bb-transition2"></div>
    </div>
    <div class="absolute left-0 right-0 top-0 bottom-0 bb-zindexn1 bb-bc-black"></div>
  </div></div>
</template>

<script>
export default {
  name: 'ReturnPolicy',
  data () {
    return {
      scrollView: null
    }
  },
  methods: {
    scrollViewScrolled: function (event) {
      this.toggleGradient(event.target)
    },
    scrolledToEnd: function (el) {
      return el.scrollHeight - el.scrollTop <= el.clientHeight
    },
    resized: function () {
      this.calcScrollViewMaxHeight(this.scrollView)
      this.toggleGradient(this.scrollView)
    },
    calcScrollViewMaxHeight: function (el) {
      var windowHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0)
      var scrollViewY = el.getBoundingClientRect().top
      var footerHeight = document.getElementById('footer').offsetHeight
      var pageMarginBottom = 8 * parseFloat(getComputedStyle(document.documentElement).fontSize)
      el.style.maxHeight = windowHeight - scrollViewY - footerHeight - pageMarginBottom + 'px'
    },
    toggleGradient: function (el) {
      if (this.scrolledToEnd(el)) {
        document.getElementById('scrollGradient').classList.add('bb-op0')
      } else {
        document.getElementById('scrollGradient').classList.remove('bb-op0')
      }
    }
  },
  mounted () {
    this.scrollView = document.getElementById('scrollView')
    this.scrollView.addEventListener('scroll', this.scrollViewScrolled)

    window.addEventListener('resize', this.resized)

    this.calcScrollViewMaxHeight(this.scrollView)
    this.toggleGradient(this.scrollView)
  },
  destroyed () {
    this.scrollView.removeEventListener('scroll', this.scrollViewScrollEnd)
    window.removeEventListener('resize', this.resized)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
::-webkit-scrollbar-track {
  background-color: gray;
}

::-webkit-scrollbar {
  width: 0.5rem;
}

::-webkit-scrollbar-thumb {
  background-color: #ff3364; 
}
</style>



// WEBPACK FOOTER //
// src/components/returnPolicy.vue